define('bwp/social/pinterest',['bwp/loader'], function(loader)
{
  if (document.getElementsByClassName('pinterest-pinit-button').length > 0) {
    loader.load_api('//assets.pinterest.com/js/pinit.js');
  }
});

